import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Database } from 'lucide-react';
import './Login.css';

const API_ROOT = process.env.NODE_ENV === 'production'
  ? (process.env.REACT_APP_API_URL || '')
  : (process.env.REACT_APP_API_URL || 'http://localhost:5001');
axios.defaults.baseURL = API_ROOT;

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [status, setStatus] = useState('checking'); // checking | ok | fail
  const [message, setMessage] = useState('Verifying your email…');
  const [email, setEmail] = useState('');

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (!token) {
        if (!cancelled) {
          setStatus('fail');
          setMessage('Missing verification token.');
        }
        return;
      }
      try {
        const res = await axios.get('/api/auth/verify-email', { params: { token } });
        if (cancelled) return;
        setStatus('ok');
        setMessage(res.data.message || 'Email verified successfully.');
        setEmail(res.data.email || '');
        toast.success('Email verified');
      } catch (err) {
        if (cancelled) return;
        setStatus('fail');
        setMessage(err?.response?.data?.error || 'Verification failed.');
        toast.error(err?.response?.data?.error || 'Verification failed');
      }
    };
    run();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="login-wrap">
      <ToastContainer theme="light" position="top-right" autoClose={4000} />
      <header className="topbar login-topbar">
        <h1 className="topbar-brand">
          <Database size={24} />
          <span>Client Management</span>
        </h1>
        <Link to="/login" className="login-nav-back">
          ← Back to sign in
        </Link>
      </header>
      <div className="login-body">
        <div className="login-card">
          {status === 'checking' && (
            <>
              <h2 className="login-title">Verifying email</h2>
              <p className="login-subtitle">{message}</p>
            </>
          )}
          {status === 'ok' && (
            <>
              <h2 className="login-title">Email verified</h2>
              <p className="login-subtitle">
                {message}
                {email ? ` (${email})` : ''}
              </p>
              <div className="login-actions">
                <Link to="/login" className="btn btn-primary login-link-btn">
                  Sign in
                </Link>
              </div>
            </>
          )}
          {status === 'fail' && (
            <>
              <h2 className="login-title">Verification failed</h2>
              <p className="login-subtitle">{message}</p>
              <div className="login-actions">
                <Link to="/login" className="btn btn-primary login-link-btn">
                  Go to sign in
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
